import { useContext } from "react";
import { AnalyticsContext } from "~/components/Analytics/AnalyticsContext";

export const useAnalyticsUserId = () =>
  useContext(AnalyticsContext).analyticsUserId;

export const useAnalyticsAnonymousId = () =>
  useContext(AnalyticsContext).analyticsAnonymousId;
